export default __webpack_public_path__ + "static/capabilitiesImg5-eec5c48e6ad3ef2525ddcdda161b283c.webp";